import type { NavGroup } from './navigation-types';
import { FINANCE_NAV_GROUPS } from './navigation-finance';

export const NAV_GROUPS: NavGroup[] = [
  {
    id: 'companies',
    label: 'Companies',
    items: [
      {
        id: 'companies',
        slug: 'companies',
        label: 'Companies',
        iconKey: 'building',
      },
    ],
  },
  {
    id: 'dashboards',
    label: 'Dashboards',
    items: [
      {
        id: 'operations',
        slug: 'operations',
        label: 'Operations',
        iconKey: 'layout-dashboard',
      },
      {
        id: 'trader',
        slug: 'trader-dashboard',
        label: 'Trader',
        iconKey: 'trending-up',
      },
      {
        id: 'lme-ticker',
        slug: 'lme-ticker',
        label: 'LME Ticker',
        iconKey: 'bar-chart-3',
      },
    ],
  },
  {
    id: 'trades-logistics',
    label: 'Trades & Logistics',
    items: [
      {
        id: 'tickets',
        slug: 'tickets',
        label: 'Tickets',
        iconKey: 'file-text',
      },
      {
        id: 'orders',
        slug: 'inventory',
        label: 'Orders',
        iconKey: 'package',
      },
      {
        id: 'orders-bl-level',
        slug: 'bl-level',
        label: 'Orders - BL Level',
        iconKey: 'file-text',
      },
    ],
  },
  {
    id: 'shipments',
    label: 'Shipments',
    items: [
      {
        id: 'shipments',
        slug: 'shipments',
        label: 'Shipments',
        iconKey: 'globe',
      },
    ],
  },
  {
    id: 'approvals-documentation',
    label: 'Approvals & Documentation',
    items: [
      {
        id: 'approvals',
        slug: 'approvals',
        label: 'Approvals',
        iconKey: 'check-circle',
        badgeKey: 'approvals-inbox',
      },
      {
        id: 'payment-approvals',
        slug: 'payment-approvals',
        label: 'Payment Approvals',
        iconKey: 'landmark',
        badgeKey: 'payment-approvals-inbox',
      },
      {
        id: 'signing',
        slug: 'signing',
        label: 'Signing',
        iconKey: 'pen-tool',
        requiredRoles: ['operations', 'admin', 'trader'],
      },
      {
        id: 'documentation',
        slug: 'documentation',
        label: 'Documentation',
        iconKey: 'folder-open',
        // Mirrors DocumentsReadGuard (card #679 F9) so blocked roles don't land
        // on a 403 page; widen here only if a blocked role gains read access.
        requiredRoles: ['operations', 'trader', 'management', 'admin'],
      },
    ],
  },
  {
    id: 'hedging',
    label: 'Hedging',
    items: [
      {
        id: 'hedging',
        slug: 'hedging',
        label: 'Hedging',
        iconKey: 'target',
      },
      {
        id: 'stonex',
        slug: 'stonex',
        label: 'StoneX Data',
        iconKey: 'trending-up',
      },
    ],
  },
  {
    id: 'claims',
    label: 'Claims',
    items: [
      {
        id: 'claims',
        slug: 'claims',
        label: 'Claims',
        iconKey: 'alert-triangle',
        // Mirrors ClaimsController read @Roles (card #679 F9) so blocked roles
        // don't land on a 403 page; widen here only if a blocked role gains read.
        requiredRoles: ['trader', 'operations', 'cfo', 'management', 'admin'],
      },
    ],
  },
  ...FINANCE_NAV_GROUPS,
  /* Scaffolding group: removed once every token and variant catalogued at
   * /design-tokens is exercised inside real feature surfaces. */
  {
    id: 'design',
    label: 'Design',
    items: [
      {
        id: 'design-tokens',
        slug: 'design-tokens',
        label: 'Design Tokens',
        iconKey: 'palette',
        comingSoon: false,
      },
    ],
  },
  {
    id: 'admin',
    label: 'Admin',
    requiredRoles: ['admin'],
    items: [
      {
        id: 'admin-notifications',
        slug: 'admin/notifications',
        label: 'Notifications',
        iconKey: 'bell',
        requiredRoles: ['admin'],
      },
    ],
  },
];
